import axios from "axios";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

export const postLoginService = async (payload: object) => {
  const res = await axios.post(`${apiURL}/metalstrading/api/users/login`, payload);
  return res;
};

export const postVerifyService = async (payload: object) => {
  const res = await axios.post(`${apiURL}/metalstrading/api/users/verify`, payload);
  return res;
};

export const postLoginNoVerifyService = async (payload: object) => {
  const res = await axios.post(`${apiURL}/metalstrading/api/users/loginnoverify`, payload);
  return res;
};

export const getIPAddressService = async () => {
  const res = await axios.get(`https://api.bigdatacloud.net/data/client-ip`);
  return res;
};
